import { createSlice } from "@reduxjs/toolkit";
import { fetchMarketingOverview, OVERVIEW_LOAD_ERROR } from "./thunkActions";

interface InitialState {
  isLoading: boolean;
  overview: IMarketingOverview | null;
  error: string | null;
}

const initialState: InitialState = {
  isLoading: false,
  overview: null,
  error: null,
};

export const marketingOverviewSlice = createSlice({
  name: "marketingOverview",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMarketingOverview.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.overview = null;
      })
      .addCase(fetchMarketingOverview.fulfilled, (state, action) => {
        state.overview = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchMarketingOverview.rejected, (state, action) => {
        state.isLoading = false;
        state.overview = null;
        state.error = action.payload ?? OVERVIEW_LOAD_ERROR;
      });
  },
});

export default marketingOverviewSlice.reducer;
export * from "./thunkActions";
